import {BaseElementAsync, OSkinableInit} from "back/commons/basis";
import {IApp, IAppCtx} from "back/core/appFrame";
import {JSX} from "lib/commons/xml/dom";
import {IReg, REG} from "lib/commons/registry";
import {DOMSH} from "lib/commons/xml/domsh";
import {IDepotEnv} from "lib/store/depot";
import {JUrlTreeAppAppDef} from "back/store/plugins/depotPlg";
import {IFrameAppParentFrame, IWindowFrameApp} from "back/core/apps/frameApp";
import {FontSizeDeskFeat, UiThemeDeskFeat} from "back/core/plugins/optionsPlg";

export interface UrlTreeApp extends BaseElementAsync, IFrameAppParentFrame {
	initialize(init: IAppCtx<IDepotEnv> & OSkinableInit): this;
}

export class UrlTreeApp extends BaseElementAsync implements IApp<IDepotEnv>, IApp<IDepotEnv>, IFrameAppParentFrame {

	reg: IReg<IDepotEnv>;

	appDef: JUrlTreeAppAppDef;

	frame: HTMLIFrameElement;

	/**
	 * Path absolu de la ressource dépot actuellement affichée
	 * ne commence pas par un "/"
	 */
	set path(val: string) {
		if (val && val.startsWith("/")) val = val.substring(1);
		if (this.appDef.utPath !== val) {
			this.appDef.utPath = val;
			this.dispatchEvent(new CustomEvent('c-appdef-change', {bubbles: true}));
		}
	}

	get path(): string {
		return this.appDef.utPath;
	}

	protected async _initialize(init: IAppCtx<IDepotEnv> & OSkinableInit) {
		this.reg = this.findReg(init);
		this.appDef = init.appDef as JUrlTreeAppAppDef;
		this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		this.setAttribute("label", init.reg.env.universe.getName());
		this.frame = this.shadowRoot.appendChild(<iframe/>) as HTMLIFrameElement;
		this.frame.addEventListener("load", () => {
			this.onPathChange();
		});
		const depotUrl = this.reg.env.universe.urlTree.url.toString();
		this.path = this.appDef.utPath || "";// Affectation initiale pour normalisation
		this.frame.src = depotUrl + this.path;
	}

	onPathChange(): void {
		const depotUrl = this.reg.env.universe.urlTree.url.toString();
		const currentUrl = this.frame.contentDocument.location.href;
		const win = this.frame.contentWindow as IWindowFrameApp;
		if (currentUrl.startsWith(depotUrl))
			this.path = currentUrl.substring(depotUrl.length);

		//déclaration du contexte parent.
		if (win.initParentFrame) win.initParentFrame(this);

		//A activer si utile
		// captureScenariProtocol(this, frameApp.reg);
	}

	updateAppDef(def: JUrlTreeAppAppDef): boolean {
		return false;
	}

	injectTheme(): void {
		if (this.frame && UiThemeDeskFeat.isIn(desk)) desk.injectThemeInSubFrame(this.frame);
		if (this.frame && FontSizeDeskFeat.isIn(desk)) desk.injectFontSizeInSubFrame(this.frame);
	}

	async hasPerm(perm: string): Promise<boolean> {
		const libPath = await REG.findScPermLibPath(perm);
		if (this.reg.env.resolver && libPath)
			await import(this.reg.env.resolver.resolvePath(libPath));
		return this.reg.hasPerm(perm);
	}
}

REG.reg.registerSkin('store-urltree-app', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
	}

	iframe {
		width: 100%;
		height: 100%;
		border: none;
	}
`);
customElements.define('store-urltree-app', UrlTreeApp);
